import React, { useState } from "react";
import { snackbarSeverity } from "./useSnackbar";
import api from "../utils/api/authApi";
import useConfirm from "./useConfirm";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { SnackbarContext } from "../contexts/Snackbar";

export const useDeleteNoId = (path, confirmationMessage, refetch, goBack) => {
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("AreYouSure"),
    t("Accept"),
    t("Cancel"),
    "warning"
  );
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submitForm = async () => {
    setLoading(true);
    getMessage(t(confirmationMessage));
    const ans = await confirm();
    if (ans) {
      try {
        const res = await api.delete(path);
        handleSnackbar(res?.data, snackbarSeverity.SUCCESS);
        if (typeof refetch == "function") {
          refetch();
        }
        if (goBack) {
          navigate(-1);
        }
      } catch (error) {
        handleSnackbar(error?.response?.data, snackbarSeverity.ERROR);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  return { loading, submitForm, getMessage, ConfirmationDialog };
};

const useFormDelete = (
  path,
  deleteId,
  confirmationMessage,
  refetch,
  goBack,
  navTo
) => {
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("AreYouSure"),
    t("Accept"),
    t("Cancel"),
    "warning"
  );
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const submitForm = async () => {
    getMessage(t(confirmationMessage));
    const ans = await confirm();
    setLoading(true);
    if (ans) {
      try {
        const res = await api.delete(path + deleteId);
        handleSnackbar(res?.data, snackbarSeverity.SUCCESS);
        if (typeof refetch == "function") {
          refetch();
        }
        if (goBack) {
          if (navTo) {
            navigate(navTo)
          } else {
            navigate(-1);
          }
        }
        return true;
      } catch (error) {
        handleSnackbar(error?.response?.data, snackbarSeverity.ERROR);
        return false;
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  return { loading, submitForm, getMessage, ConfirmationDialog };
};

export const useFormDeleteNoConfirm = (path, deleteId, refetch, goBack) => {
  const { t } = useTranslation();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const submitForm = async () => {
    setLoading(true);
    try {
      const res = await api.delete(path + deleteId);
      handleSnackbar(res?.data, snackbarSeverity.SUCCESS);
      if (typeof refetch == "function") {
        refetch();
      }
      if (goBack) {
        navigate(-1);
      }
    } catch (error) {
      handleSnackbar(error?.response?.data, snackbarSeverity.ERROR);
    } finally {
      setLoading(false);
    }
  };

  return { loading, submitForm };
};

export default useFormDelete;
